module.exports = __webpack_public_path__ + "assets/retina_CircleInTriangleDetailed.ba65dd697ff84e768ed5f8088c3cbef8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_CircleInTriangleDetailed.png
// module id = 643
// module chunks = 0